import { render, staticRenderFns } from "./waterAccountChangeGSH.vue?vue&type=template&id=97d54fda"
import script from "./waterAccountChangeGSH.vue?vue&type=script&lang=js"
export * from "./waterAccountChangeGSH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports